module.exports = __webpack_public_path__ + "nunito-sans-latin-200.3f69f8c78eb965be709fada6e9326097.woff2";